import { z } from 'zod'

/**
 * Shape check for an email address a form sends on. The server validates
 * for real; this turns an obvious typo into inline feedback before the
 * round trip.
 */
export const emailSchema = z.email('Please enter a valid email address')

export type EmailValidation = z.infer<typeof emailSchema>

export function validateEmail(value: string): string | null {
  const result = emailSchema.safeParse(value)
  return result.success ? null : (result.error.issues[0]?.message ?? null)
}
